/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var QtyHelper = /** @class */ (function () {
        function QtyHelper() {
        }
        QtyHelper.stripNonNumericCharacters = function (value) {
            return value.toString().replace(/\D/g, '');
        };
        QtyHelper.getGramsFromQty = function (qty) {
            return parseInt(QtyHelper.stripNonNumericCharsFromString(qty.toString())) * 100;
        };
        QtyHelper.stripNonNumericCharsFromString = function (numberStr) {
            return numberStr.replace(/\D/g, '');
        };
        QtyHelper.formatGrams = function (grams) {
            if (this.isKg(grams)) {
                return this.formatKg(grams);
            }
            else {
                return grams.toString() + ' g.';
            }
        };
        QtyHelper.isKg = function (grams) {
            return grams >= 1000;
        };
        QtyHelper.formatKg = function (grams) {
            return (grams / 1000).toFixed(1).toString().replace('.', ',') + ' kg.';
        };
        QtyHelper.getKgPriceFromGramPrice = function (price) {
            var kgPrice = price * 10;
            return this.thousandSeperatedNumber(kgPrice);
        };
        QtyHelper.thousandSeperatedNumber = function (value) {
            var ret = QtyHelper.stripNonNumericCharacters(value);
            return ret.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        };
        QtyHelper.getKrKgLabel = function () {
            return ' kr/kg';
        };
        return QtyHelper;
    }());

    var notification = MoyaContainer.get('core.notification');
    MoyaEventHandler.on('store.cartAdd', function (data) {
        // @ts-ignore
        if (data.data.unit !== '100g') {
            return;
        }
        data.notification.remove();
        var options = data.options;
        var notificationData = data.data;
        var title = document.createElement('div');
        title.textContent = notificationData.title;
        title.classList.add('title');
        var quantity = document.createElement('div');
        quantity.classList.add('quantity');
        quantity.textContent = QtyHelper.formatGrams(QtyHelper.getGramsFromQty(parseInt(notificationData.quantity)));
        var label = document.createElement('div');
        label.classList.add('label');
        label.textContent = notificationData.itemLabel;
        var item = document.createElement('div');
        item.appendChild(quantity);
        item.appendChild(label);
        item.classList.add('item');
        var button1 = {
            label: "Sko\u00F0a k\u00F6rfu",
            href: notificationData.cartViewUrl,
            classes: ['btn', 'btn-secondary', 'btn-small'],
        };
        options.buttons = [button1];
        if (notificationData.checkoutUrl) {
            var button2 = {
                label: 'Ganga frá kaupum',
                href: notificationData.checkoutUrl,
                classes: ['btn', 'btn-primary', 'btn-small'],
            };
            options.buttons.push(button2);
        }
        var notificationElem = notification.success('', options);
        notificationElem.classList.add('cartAdd-v1');
        notificationElem.querySelector('.notification-message').innerHTML = title.outerHTML + item.outerHTML;
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
